<template>
    <div class="wrapper" :style="commonStyle">
        <div v-if="dataReady">
            <json-by-human v-if="renderJsonByHuman">
                <!-- <div v-if="false" class="contentWrapper"> -->
                <!-- 1 glossary -->
                <!-- 显示关闭 -->
                <!-- <cell-glossary :wrapData="glossary"></cell-glossary> -->

                <!-- 2 preface -->
                <cell-preface :wrapData="preface"></cell-preface>

                <!-- 3 content -->
                <cell-content :wrapData="content"></cell-content>
            </json-by-human>

            <html-by-docpe v-if="renderHtmlByDocpe">
                <div v-html="langPackHtml"></div>
            </html-by-docpe>

            <html-by-mammoth v-if="renderHtmlByMammoth">
                <div v-html="langPackHtml"></div>
            </html-by-mammoth>

            <p class="historyBtn" v-if="showHistoryBtn" @click="goListPage">
                {{ $t("common.history") }}
            </p>
        </div>
    </div>
</template>

<script>
import cellGlossary from "@/components/cell-glossary.vue";
import cellPreface from "@/components/cell-preface.vue";
import cellContent from "@/components/cell-content.vue";
import jsonByHuman from "@/pages/render/json-by-human.vue";
import htmlByDocpe from "@/pages/render/html-by-docpe.vue";
import htmlByMammoth from "@/pages/render/html-by-mammoth.vue";
import { mapState, mapMutations } from "vuex";
import * as utils from "@/utils";
import { RENDER_TEMPLATE_ENUM, DEAFULT_VERSION } from "@/../config/config.js";
import { getFallbackLang } from "@/utils/const/lang-support-map.js";

let trace = new utils.Trace("首页", true);

export default {
    name: "home",
    components: {
        cellGlossary,
        cellPreface,
        cellContent,
        jsonByHuman,
        htmlByDocpe,
        htmlByMammoth
    },
    data() {
        return {
            versionList: utils.CONST.privacy.versionList,

            dataReady: false, // 数据是否准备好

            // world: {},              //

            // 语言数据
            langPack: {
                // glossary: { title: '123' } // 关闭显示
            },
            langPackHtml: null,

            // 定时器获取语言包
            count: 0, // 次数
            langInterval: null, // 获取语言吧定时器

            //
            msg: "Welcome to Your Vue.js App",
            showHistoryBtn: true
        };
    },
    computed: {
        ...mapState(["language", "version"]),
        // 名词解释
        // 关闭显示
        // glossary() {
        //     return this.langPack.glossary || {}
        // },
        // 前言
        preface() {
            return this.langPack.preface || {};
        },
        // 内容
        content() {
            return this.langPack.content || {};
        },
        commonStyle() {
            if (this.language.lang === "sa") {
                return {
                    direction: "rtl",
                    "unicode-bidi": "bidi-override"
                };
            }
        },
        privacySelected() {
            console.log(this.version, 9999999);
            return utils.CONST.privacy.versionMap[this.version] || {};
        },
        renderJsonByHuman() {
            return (
                this.privacySelected.renderTemplate ===
                RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN
            );
        },
        renderHtmlByDocpe() {
            return (
                this.privacySelected.renderTemplate ===
                RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE
            );
        },
        renderHtmlByMammoth() {
            console.log(this.privacySelected.renderTemplate);

            return (
                this.privacySelected.renderTemplate ===
                RENDER_TEMPLATE_ENUM.HTML_BY_MAMMOTH
            );
        }
    },
    methods: {
        ...mapMutations(["setLanguage", "setVersion"]),
        // init
        async init() {
            try {
                await this.getLocalLang();
                await this.$nextTick();
                this.dataReady = true;
            } catch (err) {
                console.log(err);
                if (this.language.privacy !== "en") {
                    trace(
                        `获取隐私条款(${this.language.privacy})失败,默认用en`
                    );
                    this.setLanguage({ privacy: "en" });
                    await this.getLocalLang();
                    await this.$nextTick();
                    this.dataReady = true;
                }
            }
        },
        // 获取本地语言包
        getLocalLangPack(url) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get(url)
                    .then(res => {
                        // 获取到了语言包，处理逻辑
                        resolve(res.data);
                    })
                    .catch(error => {
                        // 获取不到语言包，则使用默认
                        reject(error);
                    });
            });
        },
        // URL中获取参数（支持从query string和hash中的query string获取）
        getUrlParam(name) {
            // 优先从hash中的query string查找（#/path?参数 的部分）
            let hash = window.location.hash;
            if (hash && hash.indexOf("?") !== -1) {
                // 提取hash中?后面的部分
                let hashQuery = hash.substring(hash.indexOf("?") + 1);
                let hashParamArr = hashQuery.split("&");
                for (let i = 0; i < hashParamArr.length; i++) {
                    let pair = hashParamArr[i].split("=");
                    if (pair[0] == name) {
                        return pair[1];
                    }
                }
            }
            
            // 如果在hash中没找到，则从主URL的query string中查找（? 后面的部分）
            let query = window.location.search.substring(1);
            let param_arr = query.split("&");
            for (let i = 0; i < param_arr.length; i++) {
                let pair = param_arr[i].split("=");
                if (pair[0] == name) {
                    return pair[1];
                }
            }
            
            return null;
        },
        async getLocalLang() {
            // 获取回退语言：如果请求的语言不支持，则使用英文；如果英文也不支持，则使用第一个支持的语言
            const targetLang = getFallbackLang(
                this.privacySelected.file,
                this.language.privacy
            );

            if (!targetLang) {
                trace(
                    `版本 ${this.privacySelected.file} 没有可用的语言文件`
                );
                throw new Error("没有可用的语言文件");
            }

            // 如果回退到了其他语言，记录日志
            if (targetLang !== this.language.privacy) {
                trace(
                    `版本 ${this.privacySelected.file} 不支持语言 ${this.language.privacy}，使用 ${targetLang} 代替`
                );
            }

            switch (this.privacySelected.renderTemplate) {
                case RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN:
                    {
                        let url = `./static/langPack/${this.privacySelected.file}/${targetLang}.json`; // 使用回退后的语言
                        trace("获取隐私条例的路径:", url);
                        this.langPack = await this.getLocalLangPack(url);
                    }
                    break;

                case RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE:
                case RENDER_TEMPLATE_ENUM.HTML_BY_MAMMOTH:
                    {
                        let url = `./static/langPack/${this.privacySelected.file}/${targetLang}.html`; // 使用回退后的语言
                        trace("获取隐私条例的路径:", url);
                        this.langPackHtml = await this.getLocalLangPack(url);
                    }
                    break;

                default:
                    break;
            }
        },
        goListPage() {
            this.$router.push({
                name: "listPage"
            });
        }
    },
    created() {
        trace("编译的环境", process.env);

        let lang = (this.getUrlParam("lang") || "en").toLowerCase(); //!从参数中获取语言，若没法获取,强制为 en
        if (this.$i18n.messages[lang] == undefined) {
            this.$i18n.locale = "en";
            trace(`应用主体不支持该语言(${lang})， 强制英语`);
        } else {
            this.$i18n.locale = lang;
        }

        this.setLanguage({ lang, locale: this.$i18n.locale, privacy: lang });
        trace(`语言:`, this.language);

        console.log(DEAFULT_VERSION, process.env.OEM_APP, 8888888);

        let version = (
            this.getUrlParam("version") ||
            DEAFULT_VERSION ||
            ""
        ).toLowerCase(); //!从参数中获取版本，若没法获取，就用配置中默认的版本

        trace("version", version);
        if (!this.versionList.includes(version)) {
            trace(`${process.env.OEM_APP}不支持该版本(${version}),用最后一个`);

            version = this.versionList[
                Math.max(this.versionList.length - 1, 0)
            ];
        }
        this.setVersion(version);

        trace("版本列表:", this.versionList);
        trace(`使用的版本:${this.version}`);
        trace("版本详情:", this.privacySelected);
        trace(`渲染模板的方式:${this.privacySelected.renderTemplate}`);

        this.showHistoryBtn =
            this.getUrlParam("show") === "false" ? false : true;
        trace(`是否显示历史版本:${this.showHistoryBtn}`);

        this.init();
    }
};
</script>

<style lang="less">
.wrapper {
    .historyBtn {
        /* position: absolute;
        top: 0px; */

        font-size: 18px;
        width: 200px;
        height: 60px;
        color: #1a63e0;
        line-height: 60px;

        // border: 1px solid red;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue